import React from 'react';
import SubTaskItem, { type SubTaskItemLayout } from '@/components/SubTaskList/SubTaskItem';

export interface SubTaskListItem {
  id: string;
  label: string;
  details?: React.ReactNode;
  anchorId?: string;
}

export interface SubTaskListProps {
  items: SubTaskListItem[];
  completed: boolean[];
  onToggle: (index: number) => void;
  /** Only this row’s “I Did This” / checkbox / unmark controls are disabled while a sync is in flight. */
  syncingRowIndex?: number | null;
  idPrefix?: string;
  listLabel?: string;
  layout?: SubTaskItemLayout;
  /** Tasklist: hide “I Did This” until row hover / keyboard focus (done state stays visible). */
  revealDidThisOnHover?: boolean;
  /** Teacher preview: view content only — no subtask completion controls. */
  readOnly?: boolean;
}


const SubTaskList: React.FC<SubTaskListProps> = ({
  items,
  completed,
  onToggle,
  syncingRowIndex = null,
  idPrefix = 'subtask',
  listLabel = 'Subtasks',
  layout = 'default',
  revealDidThisOnHover = false,
  readOnly = false,
}) => {
  if (!items.length) return null;

  return (
    <ul
      className={`sub-task-list${layout === 'tasklistAccordion' ? ' sub-task-list--tasklist-accordion' : ''}${revealDidThisOnHover ? ' sub-task-list--reveal-did-this-hover' : ''}`}
      aria-label={listLabel}
    >
      {items.map((item, index) => (
        <SubTaskItem
          key={item.id}
          itemId={`${idPrefix}-${item.id}`}
          anchorId={item.anchorId}
          label={item.label}
          completed={Boolean(completed[index])}
          disabled={readOnly || (syncingRowIndex !== null && syncingRowIndex === index)}
          layout={layout}
          readOnly={readOnly}
          onToggleComplete={() => onToggle(index)}
        >
          {item.details}
        </SubTaskItem>
      ))}
    </ul>
  );
};

export default SubTaskList;
